import { ImageType } from 'types/image';

export const getFirstImage = (apiData: string[] | null): string | null => {
    if (apiData === null || !(0 in apiData)) {
        return null;
    }

    return apiData[0];
};

export const getFirstImageType = (apiData: ImageType[] | null): ImageType | null => {
    if (apiData === null || !(0 in apiData)) {
        return null;
    }

    return apiData[0];
};

export const getImageUrl = (image: ImageType | null): string | null => {
    return image?.url ?? null;
};
